import React from 'react';
import animationData from 'assets/animations/checkmark.json';
import Lottie from 'react-lottie';

type CheckIconProps = {
  size?: number;
  loop?: boolean;
  autoplay?: boolean;
};

export default class CheckIcon extends React.Component<CheckIconProps> {
  render() {
    const {size = 200, loop = false, autoplay = true} = this.props;
    const defaultOptions = {
      loop,
      autoplay,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    return <Lottie options={defaultOptions} height={size} width={size} />;
  }
}
